import { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  UPSERT_QUANTITIY_UNIT,
  CREATE_REGION,
  UPSERT_LOGISTIC_MATERIAL,
  CREATE_COUNTRIES,
  CREATE_PORT_OF_LOADING,
  CREATE_PORT_OF_DESTINATION,
  CREATE_INCOTERMS,
  CREATE_PRICE_INDEXES,
  CREATE_OTHER_PRODUCT,
} from '../graphqlDefs/masters/mutations';
import {
  QUANTITYUNITLIST,
  REGIONLIST,
  LOGISTICMATERIALLIST,
  COUNTRIESLIST,
  PORTOFLOADINGLIST,
  INCOTERMSLIST,
  PRICEINDEXESLIST,
  OTHERPRODUCTSLIST,
} from '../constants/Masters';
import '../App.css';

const MasterStandardApp = () => {
  const client = useApolloClient();
  const { id } = useParams();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Navigates back one step
  };
  const [importType] = id.split('&');
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [activeLoader, setActiveLoader] = useState(false);
  const [allData, setAllData] = useState([
    {
      data: QUANTITYUNITLIST,
      mutation: UPSERT_QUANTITIY_UNIT,
      tableName: 'Quantity Unit',
      isChecked: false,
      hasError: false,
    },
    {
      data: REGIONLIST,
      mutation: CREATE_REGION,
      tableName: 'Region',
      isChecked: false,
      hasError: false,
    },
    {
      data: LOGISTICMATERIALLIST,
      mutation: UPSERT_LOGISTIC_MATERIAL,
      tableName: 'Logistic Material',
      isChecked: false,
      hasError: false,
    },
    {
      data: COUNTRIESLIST,
      mutation: CREATE_COUNTRIES,
      tableName: 'Countries',
      isChecked: false,
      hasError: false,
    },
    {
      data: PORTOFLOADINGLIST,
      mutation: CREATE_PORT_OF_LOADING,
      tableName: 'Ports Of Loading',
      isChecked: false,
      hasError: false,
    },
    {
      data: PORTOFLOADINGLIST,
      mutation: CREATE_PORT_OF_DESTINATION,
      tableName: 'Ports Of Destination',
      isChecked: false,
      hasError: false,
    },
    {
      data: INCOTERMSLIST,
      mutation: CREATE_INCOTERMS,
      tableName: 'Incoterms',
      isChecked: false,
      hasError: false,
    },
    {
      data: PRICEINDEXESLIST,
      mutation: CREATE_PRICE_INDEXES,
      tableName: 'Price Indexes',
      isChecked: false,
      hasError: false,
    },
    {
      data: OTHERPRODUCTSLIST,
      mutation: CREATE_OTHER_PRODUCT,
      tableName: 'Other Products',
      isChecked: false,
      hasError: false,
    },
  ]);

  useEffect(() => {
    const allCheckedOrError = allData.every(
      (item) => item.isChecked || item.hasError
    );
    if (allCheckedOrError) {
      setActiveLoader(false);
    }
  }, [allData]);

  const saveMasterStandardData = async (data, mutation, index) => {
    try {
      const { data: responseData, error } = await client.mutate({
        mutation: mutation,
        variables: { input: data },
      });

      // Update isChecked state for the corresponding table
      const updatedData = [...allData];
      updatedData[index].isChecked = true;
      setAllData(updatedData);

      return { success: true, message: 'Success' };
    } catch (error) {
      console.error('Error saving master standard data:', error);

      // Update hasError state for the corresponding table
      const updatedData = [...allData];
      updatedData[index].hasError = true;
      setShowValidationMessage(true);
      setAllData(updatedData);

      return { success: false, error };
    }
  };

  const handleImport = async () => {
    setActiveLoader(true);
    for (let i = 0; i < allData.length; i++) {
      const rest = await saveMasterStandardData(
        allData[i].data,
        allData[i].mutation,
        i
      );
    }
  };

  return (
    <div className='App'>
      <div className='container-wrapper'>
        <div className='loading-data'>
          <div className='loading-list-box'>
            <ul className='loading-list'>
              {allData.map((item, index) => (
                <li
                  key={index}
                  className={item.isChecked ? 'success-upload' : ''}
                >
                  <label className={item.hasError ? 'failed-label' : ''}>
                    <input
                      type='checkbox'
                      className='le-checkbox'
                      checked={item.isChecked}
                      readOnly
                    />
                    {item.tableName}
                  </label>
                </li>
              ))}
            </ul>
          </div>
          {showValidationMessage ? (
            <span>Marked with red color tables data are not inserted.</span>
          ) : (
            <></>
          )}
          <div className='ClicktoImportBtn'>
            <LoadingButton
              type='button'
              className={activeLoader ? 'master-btn-lodr' : 'master-btn-rglr'}
              variant='outlined'
              onClick={handleImport}
              loading={activeLoader ? 'loading' : undefined}
              style={{ cursor: 'pointer' }}
            >
              Click to import
            </LoadingButton>
            <button
              className='master-btn-rglr'
              onClick={handleGoBack}
              style={{ cursor: 'pointer' }}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterStandardApp;